import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Service from '../services/Service';
import showToast from '../../../../Shared/Utils/ToastNotification';
import './JotformAnswersModal.css';

const JotformAnswersModal = ({ patient, onClose }) => {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSubmissions();
  }, []);

  const fetchSubmissions = async () => {
    try {
      const res = await Service.getPatientJotformSubmissions(patient.id);
      setSubmissions(res.data || []);
    } catch (error) {
      showToast('error', 'Failed to fetch intake form answers');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="jotform-modal-overlay" onClick={onClose}>
      <div className="jotform-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="jotform-modal-header">
          <h2>Medical Intake Answers</h2>
          <button className="jotform-close-btn" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="jotform-modal-body">
          <p
            className="patient-info"
            style={{
              marginBottom: '20px',
              padding: '14px 16px',
              background: 'linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%)',
              borderRadius: '8px',
              borderLeft: '4px solid #3b82f6',
              color: '#1e40af',
            }}
          >
            Patient:{' '}
            <strong>
              {patient.first_name} {patient.last_name}
            </strong>{' '}
            ({patient.email})
          </p>

          {loading ? (
            <p>Loading answers...</p>
          ) : submissions.length === 0 ? (
            <p>No intake form submissions found for this patient.</p>
          ) : (
            submissions.map((sub, idx) => (
              <div key={idx} className="jotform-submission">
                <div className="jotform-submission-header">
                  <span className={`jotform-badge ${sub.status}`}>{sub.status}</span>
                </div>

                {sub.case_questions && sub.case_questions.length > 0 ? (
                  <div className="jotform-qa-list">
                    {sub.case_questions.map((qa, qIdx) => (
                      <div key={qIdx} className="jotform-qa-item">
                        <div className="jotform-question">
                          {qIdx + 1}. {qa.question}
                        </div>
                        <div className="jotform-answer">{qa.answer || 'Not answered'}</div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p>No answers recorded for this submission.</p>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

JotformAnswersModal.propTypes = {
  patient: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default JotformAnswersModal;
